<template>
  <modal-vue :visible.sync="isVisible" :content_loaded="true" :title="t('user_subscription_login.iniciar_sesion')">
    <template v-slot:header> {{ t("user_subscription_login.iniciar_sesion") }} </template>
    <template v-slot:body>
      <user-subscription-login-form-vue ref="login_form_vue" :must_redirect= false @login:success="handleLoginSuccess" />
    </template>
    <template v-slot:footer>
      <div class="col-12 px-0">
        <div class="col-12 d-flex justify-content-end px-0 pb-3" v-if="!loadingLogin">
          <button id="iniciar" @click="handleLogin" class="btn btn-primary mr-md-3">
            {{ t("entrar") }}
          </button>
          <button id="cancelar" @click="hide" class="btn btn-secondary">
            {{ t("cancel") }}
          </button>
        </div>
        <div class="card card-info mb-3">
          <div class="card_body p-3 text-center">
            {{ t("user_subscription_login.required_text") }}
          </div>
        </div>
        <div class="col-12 px-0">
          <p class="text-center mb-0 register__link pb-3">
            {{ t("user_subscription_login.required_user_text") }}
            <a :href="urlToRegister" target="_blank">{{ t("register") }}</a>
          </p>
        </div>
      </div>
    </template>
  </modal-vue>
</template>

<script>
import mixins from "common/mixins"
import { mapState } from 'vuex';

export default {
  name: "user-subscription-modal-login-vue",
  mixins: [mixins.translate],
  components: {
    "modal-vue": () =>
      import(/* webpackChunkName: "[request]" */ "components/Modal"),
    "user-subscription-login-form-vue": () =>
      import(/* webpackChunkName: "[request]" */ "components/user_subscription/LoginForm")
  },
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    show() { this.isVisible = true },
    hide() {
      this.isVisible = false
    },
    handleLogin(){
      this.$refs.login_form_vue.try_send_data()
    },
    handleLoginSuccess({ login_action }){
      if(login_action){
        this.$emit("login:success")
      }
      this.hide()
    }
  },
  computed: {
    urlToRegister(){
      return gon.url_for.user_subscriptions_register_tab
    },
    ...mapState(['loadingLogin'])
  }
};
</script>
